/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_Cmp_5_TInputs */

const en_cp_cmp_5_t = /** @type {(inputs: Cp_Cmp_5_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`One deadline; a demo that has to look like it works.`)
};

const id_cp_cmp_5_t = /** @type {(inputs: Cp_Cmp_5_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lomba dengan satu tenggat; demo yang harus terlihat jalan.`)
};

/**
* | output |
* | --- |
* | "One deadline; a demo that has to look like it works." |
*
* @param {Cp_Cmp_5_TInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_cmp_5_t = /** @type {((inputs?: Cp_Cmp_5_TInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_Cmp_5_TInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_cmp_5_t(inputs)
	return en_cp_cmp_5_t(inputs)
});